import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Comments from "../../../reservations/components/subcompdash/Comments";
import CarDetailSection from "../../../cars/components/cardetails/CarDetailSection";

function CustomerCommentsTab({ userId }) {
    const { t } = useTranslation("customers");

    return (
        <CarDetailSection title={t("customerDetail.comments")} embedded className="!mt-0" noPadding>
            <div className="px-4 pb-4">
                <Comments data={userId} />
            </div>
        </CarDetailSection>
    );
}

CustomerCommentsTab.propTypes = {
    userId: PropTypes.string.isRequired,
};

export default CustomerCommentsTab;
